<template>
  <div id="vHeader">
    <div class="container" style="padding-left: 0; padding-right: 0;">
      <div v-bind:style="{'background': headerColor}" style="position: relative;">
          <div class="head_linker">
            <a class="head_a" href="#"  @click.prevent="contactUs()"> {{$t('message.Contact_txt')}} </a> | <a class="head_a" href="https://www.ncut.edu.tw" target="_blank"> {{$t('message.Home_txt')}} </a>
          </div>
          <h1 class="cy-header" v-bind:style="{'background-image': headerImg}" style="padding: 0.25rem; text-align: left;"><img src="@/assets/images/logo0506.png" style="height: 80px; " alt="NCUT勤益校徵圖示" title="四技技優甄審" /><small class="text-muted" style="vertical-align: text-bottom;" 
            v-bind:style="{'color': titleColor}"
            v-if="setting!=null">{{setting.sysTitle[0].codeName}}</small></h1>
          <span class="locale-changer" v-if="false">
            <el-radio-group v-model="$i18n.locale" size="mini" style="vertical-align: top;">
              <el-radio-button 
                v-for="(lang, i) in langs"
                :key="`Lang${i}`"
                :label="lang[0]" >{{lang[1]}}</el-radio-button>
            </el-radio-group>
          </span>
      </div>
      <div class="menu_bar">
          <el-menu :default-active="pageInfo[($store.getters.getAppId<0?0:$store.getters.getAppId)].subMenu[($store.getters.getPageId<0?0:$store.getters.getPageId)].menuID" class="el-menu-demo" mode="horizontal" @select="handleSelect"
              v-if="pageInfo!=null"
              background-color="#00bfff"
              text-color="#fff"
              active-text-color="#EEDEB0">
            <el-menu-item style="padding: 0 1.125rem;"
              v-for="(it,index) in menuList" :key="it.menuID" :index="it.menuID" :name="it.menuID"
              @click="toggle(0, index)">
              <template slot="title">{{it.title}}</template>
            </el-menu-item>
            <el-menu-item style="float:right;" index='logout'
              v-if="user.status=='1'">
                <span style="padding: 1em 0 0;">
                    <span style="font-weight:bolder; color:#003371; vertical-align: middle;">{{user.name}} ,您好</span>
                    <a class="head_a" href="#" @click.prevent="logout()"> 登出 </a>
                </span>
            </el-menu-item>
          </el-menu>
      </div>
      <div class="cy-partition-line-solid mt-1 cy-bc">
        <h2 class="alert alert-success" style="text-align: left; margin: 0.1em 0;">{{sysTitle}}<span  class="pull-right" style="font-size: large; padding-top: 0.75em; color: darkslateblue;" v-if="0<user.dId">{{user.dptcd}}/{{user.dptnm}}</span></h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'vheader',
  props: [
    'pageInfo',
    'activeIndex'
  ],
  data () {
    return {
      langs: [
        ['tw', '繁'],
        ['cn', '簡'],
        ['en', 'En']
      ],
      curPage: {
        appId: 0,
        pageId: 0
      }
    }
  },
  computed: {
    sysId () {
      return this.$store.getters.getSysId
    },
    setting () {
      return this.$store.getters.getSetting
    },
    sysTitle () {
      return this.$store.getters.getSysTitle
    },
    user () {
      return this.$store.getters.getUser
    },
    menuList: function () {
      console.log('HeaderView: menuList')
      if ((this.pageInfo != null) && (this.pageInfo.length > 0)) {        
        var smenuList = this.pageInfo[0].subMenu;
        return smenuList.filter(function (item) {
          return item.setting>0
        })  
      }
      return [];
    },
    headerImg () {
      let url = '';
      if (this.setting!=null && this.setting.headerFile != null && this.setting.headerFile[0]!= null && this.setting.headerFile[0].codeName.length>0) {
         url  = 'url(./WebApi/Tools/ShowSystemDoc/'.concat(this.$store.getters.getSysId).concat('/').concat(6).concat(')');
      }
      return url
    },
    headerColor () {
      let url = '';
      if (this.setting!=null && (this.setting.headerFile == null || this.setting.headerFile[0]== null || this.setting.headerFile[0].codeName.length==0)) {
         url  = 'linear-gradient(45deg,#fefcea 0%,#f1da36 100%)';
      }
      return url
    },
    titleColor () {
      let url = '';
      if ((this.setting != null) && (this.setting.titleColor != null) && (null != this.setting.titleColor[0])) {
         url  = this.setting.titleColor[0].codeName.concat('!important');
      }
      return url;
    }
  },
  filters: {
    dateFormat: function (input) {
      console.log('HeaderView: dateFormat')
      var d = new Date(input)
      var year = d.getFullYear()
      var month = d.getMonth() + 1
      var day = d.getDate() < 10 ? '0' + d.getDate() : '' + d.getDate()
      var hh = d.getHours()
      var ss = d.getMinutes()
      return year + '年' + month + '月' + day + '日' + hh + '時' + ss + '分'
    }
  },
  methods: { 
    // pageTitle: function () {
    //   let url = ''
    //   if ((this.$store.getters.getAppId == -2) && (this.$store.getters.getPageId == -2)) {
    //     url = '連絡我們'
    //   } else if ((this.pageInfo != null) && (this.$store.getters.getAppId > -1) && (this.$store.getters.getPageId > -1)) {
    //     var appId = this.$store.getters.getAppId
    //     var pageId = this.$store.getters.getPageId 
    //     url = this.pageInfo[appId].subMenu[pageId].title
    //   }
    //   console.log('======url===== :' + url)
    //   //return url;
    //   this.$store.dispatch('setSysTitle', url)
    // },
    contactUs: function() {
      // this.$store.dispatch('actionAppId', -2)
      // this.$store.dispatch('actionPageId', -2)
      // this.$emit('setCurComp', 'Help')
      this.$emit('toggle', -2, -2)
    },
    toggle: function (appId, pageId) {
      // console.log('toggle call' + appId, pageId)
      // this.$store.dispatch('actionAppId', appId)
      // this.$store.dispatch('actionPageId', pageId)
      // this.$emit('setCurComp', this.pageInfo[appId].subMenu[pageId].path)
      // this.pageTitle();
      this.$emit('toggle', appId, pageId)
    },
    handleSelect: function (key, keyPath) {
      //console.log(key, keyPath)
    },
    logout: function () {
      console.log('HeaderView: logout')
      var user = {
        eId: this.setting.enrollID[0].codeName,
        gId: -1,
        dId: -1,
        stdId: -1,
        text1: this.$store.state.user.id,
        text2: '',
        text3: '',
        isLogin: false
      }
      var vm = this
      this.$http.put('./WebApi/Common/Authorized', user)
        .then((response) => {
          if (response.data != null) {
            console.log('logout' + vm.user.id)
            vm.$store.dispatch('resetLogin');
            vm.$emit('getDefaultMenu', this.sysId, false);
            //window.location.reload(true);
            //vm.$router.go();
          } else {
            vm.$notify.error({
                              title: vm.$t('message.Error_txt'),
                              dangerouslyUseHTMLString: true,
                              message: '<strong>登出失敗</strong>',
                              offset: 150
                            });
          }
        })
        .catch(function (error) {
          vm.$notify.error({
                            title: vm.$t('message.Error_txt'),
                            dangerouslyUseHTMLString: true,
                            message: '<strong>對不起,網路連線失敗' + error+'</strong>',
                            offset: 150
                          });
        })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import '../assets/styles/ceintake.css';
.header {
  display: contents;
}
.head_a {
  color: white;
  text-decoration: none;
  font-size: 12px;
  font-family: verdana, 'trebuchet ms', sans-serif;
}
.head_linker {
  background-color: rgba(33,99,33, 0.2);
  position: absolute;
  right: 0.25rem;
  top: 0.125rem;
}
.locale-changer {
    position: absolute;
    top: 0.125rem;
    right: 10rem;
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderView.vue